

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import * as format from "@/util/format";
import { ValidationRule } from "@/util";

@Component
export default class MoneyField extends Vue {
  hasError = false;
  @Prop({ default: 0 }) value!: number;
  @Prop({ default: "" }) label!: string;
  @Prop({ default: "" }) cssClass!: string;
  @Prop({ default: false }) cents!: boolean;
  @Prop({ default: false }) filled!: boolean;
  @Prop({ default: false }) solo!: boolean;
  @Prop({ default: false }) flat!: boolean;
  @Prop({ default: false }) hideDetails!: boolean;
  @Prop({ default: false }) required!: boolean;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: () => [] }) rules!: ValidationRule[];

  valueString = "";
  money = {
    decimal: ",",
    thousands: ".",
    precision: 2,
    masked: false
  };

  created() {
    this.onValue(this.value, -2);
  }

  toValue(val: number): number {
    if (this.cents) {
      return Math.round(val * 100);
    }
    return val;
  }

  toMoney(val: number): number {
    if (this.cents) {
      return val / 100;
    }
    return val;
  }

  @Watch("value")
  onValue(newValue: number, oldValue: number) {
    if (newValue !== oldValue) {
      this.valueString = format.printMoney(this.toMoney(newValue));
    }
  }

  @Watch("valueString")
  onValueString(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.$emit("input", this.toValue(util.moneyToNumber(newValue)));
    }
  }

  get localRules() {
    return uiUtil.rulesRunner(this);
  }
}
